import { SHIPPING_GROUP_NAMES } from '@/constants/delivery';
import { GtmEvents } from '@/gtm/gtm-events';

export class CartProductGtmEvents extends GtmEvents {
  constructor() {
    super('СобытияВКорзине');
  }

  quantityClick(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Количество_Изменить',
      eventLabel: productId,
    });
  }

  quantityChange(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Количество_Изменено',
      eventLabel: productId,
    });
  }

  productInSoldoutGroupVisible(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Распродан',
      eventLabel: productId,
    });
  }

  removeSoldoutGroup() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Удалить_Распродано_Все',
    });
  }

  removeProduct({ groupType, productId }) {
    if (groupType === SHIPPING_GROUP_NAMES.soldout) {
      return this.gtmEvent({
        eventAction: 'КРЗ_Удалить_Распродано',
        eventLabel: productId,
      });
    }
    return this.gtmEvent({
      eventAction: 'КРЗ_Удалить',
      eventLabel: productId,
    });
  }

  toggleFavoriteState({ productId, isActive }) {
    if (isActive) {
      return this.gtmEvent({
        eventAction: 'КРЗ_ДобавитьВИзбранное',
        eventLabel: productId,
      });
    }
  }

  togglePersonalPriceState(ids) {
    return this.gtmEvent({
      eventAction: 'КРЗ_ПерсЦена_Скидки',
      eventLabel: JSON.stringify(ids),
    });
  }

  editClick(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Редактировать',
      eventLabel: productId,
    });
  }

  editClose(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Ред_Закрыть',
      eventLabel: productId,
    });
  }

  editSave(productId, { isSizeChanged, isColorChanged, isQuantityChanged }) {
    const label = [];

    if (isSizeChanged) {
      label.push('Размер');
    }
    if (isColorChanged) {
      label.push('Цвет');
    }
    if (isQuantityChanged) {
      label.push('Количество');
    }

    return this.gtmEvent({
      eventAction: 'КРЗ_Ред_Изменен',
      eventLabel: JSON.stringify({
        ЦМ: productId,
        'Цвет|Размер|Количество': label,
      }),
    });
  }

  editToggleFavoriteState({ productId, isActive }) {
    if (isActive) {
      return this.gtmEvent({
        eventAction: 'КРЗ_Ред_ДобавитьВИзбранное',
        eventLabel: productId,
      });
    }
  }

  editSwipeMediaGallery(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Ред_ФотоСкроллСвайп',
      eventLabel: productId,
    });
  }

  editClickArrowMediaGallery(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Ред_ФотоСкроллКлик',
      eventLabel: productId,
    });
  }

  editClickItemMediaGallery(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Ред_ФотоКлик',
      eventLabel: productId,
    });
  }

  editClickSize(productId) {
    return this.gtmEvent({
      eventAction: 'КРЗ_Ред_ТаблицаРазмеров',
      eventLabel: productId,
    });
  }
}

export const cartProductGtmEvents = new CartProductGtmEvents();
